import AuthorPage from '../../../components/AuthorPage/AuthorPage';
import ZPALayout from '../../../components/ZPALayout/ZPALayout';
import { buildPrimaryAuthorPage } from '../../../util/buildPrimaryAuthorPage';

// Build the page using the utility
const { getStaticProps, getStaticPaths, Page } = await buildPrimaryAuthorPage({
    site: 'ZPA',
    LayoutComponent: ZPALayout,
    ContentComponent: AuthorPage,
    menuPropName: 'submenu',
    hasStickyNav: true,
});

// Next.js expects named exports, so we use a wrapper
export { getStaticProps, getStaticPaths };

export default Page;
